<template>
	<div class="assessSuccess">
		<nav-bar title="修改密码"></nav-bar>
		<!-- <div v-if=" type == true"> -->
		<div class="mobilephone">
			<p>修改密码</p>
			<p>密码为8-16位，须包含数字、字母、至少2种 元素</p>
		</div>
		<div class="mobilephone-box">
			<van-cell-group>
				<van-field v-model="oldPasswd" type="password" placeholder="请输入旧密码" />
			</van-cell-group>
			<van-cell-group>
				<van-field v-model="newPasswd1" type="password" placeholder="请输入新密码" />
			</van-cell-group>
			<van-cell-group>
				<van-field v-model="newPasswd" type="password" placeholder="请再次输入新密码" />
			</van-cell-group>
		</div>
		<div class="btn">
			<van-button @click="getData()" type="primary" color="rgba(33,37,41,1)" block>确定
			</van-button>

		</div>
		<!-- </div> -->
		<!-- <van-empty image="network" description="404"  v-if="type2 ==false"/> -->
	</div>
</template>

<script>
	import Vue from "vue";
	import NavBar from "@/components/navBar";
	import {
		Field,
		CellGroup,
		Button,
		Dialog,

	} from "vant";
	Vue.use(Field);
	export default {
		name: "changePassword",
		data() {
			return {
				type: false,
				type2: false,
				accountId: localStorage.getItem('accountUid'),
				newPasswd: "",
				newPasswd1: "",
				oldPasswd: ""
			};
		},
		computed: {},
		created() {

		},
		watch: {},
		methods: {
			validate: function() {
				var passwordreg =/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/
				if (this.newPasswd1 == "" || this.newPasswd == "" || this.oldPasswd == "") {
					Dialog({
						message: "密码不能为空"
					});
					return false
				} else if (this.newPasswd1.length < 8 || this.newPasswd.length < 8 || this.oldPasswd.length < 8) {
					Dialog({
						message: "密码不能小于8位"
					});
					return false
				} else if (this.newPasswd1 != this.newPasswd) {
					Dialog({
						message: "两次密码输入不一致"
					});
					return false
				} else if (!passwordreg.test(this.newPasswd1)) {
					Dialog({
						message: "密码必须由数字、字母、组合,请输入8-16位"
					});
					return false

				}
				return this.newPasswd;
			},

			getData() {
				if (this.validate()) {
					var that = this
					Dialog.confirm({
						title: '修改密码',
						message: '是否确定修改密码?'
					}).then(() => {
						this.$axios.post('/vedm/accountH5/modifyAccountLoginPasswd', {
								accountId: that.accountId,
								newPasswd: that.newPasswd,
								oldPasswd: that.oldPasswd
							}, {
								headers: {
									Authorization: localStorage.getItem('token')
								}
							}).then(function(res) {
								Dialog({
									message: res.data.msg
								});
							})
							.catch(function(error) {
								console.log(error)
								window.app.showReLoginDialog()
							});

					}).catch(() => {
						// on cancel
					});
				}

			}
	
		},
		components: {
			NavBar,
			"van-cell-group": CellGroup,
			"van-button": Button,
			// "van-empty":Empty
		}
	};
</script>

<style scoped lang="less">
	.mobilephone {
		margin-top: 30px;
		padding-left: 20px;
	}

	.mobilephone-box {
		margin-top: 40px;
	}

	.mobilephone p:nth-child(1) {
		font-size: 26px;
	}

	.mobilephone p:nth-child(2) {
		font-size: 14px;
	}

	.btn {
		width: 375px;
		height: 112px;
		background: rgba(255, 255, 255, 1);
		padding: 15px 25px;
		box-sizing: border-box;
		margin: auto;
		margin-top: 60px;
	}

	.van-button--primary {
		background: #ff9500;
		border: 1px solid #ff9500;
	}
</style>
